import functions from './functions';

function stickyCheckout(){

    window.addEventListener('scroll', (event) => {
        let stickyDiv = document.querySelector('.checkout-page__sticky'),
            actionDiv = document.querySelector('.checkout-page__actions').getBoundingClientRect();

        if (scrollY >= actionDiv.top + window.innerHeight) {
            stickyDiv.classList.add('hidden');
        } else {
            stickyDiv.classList.remove('hidden');
        }
    });

}



function init(){
    if (functions.checkPage('checkout-page')) {
        if (window.innerWidth < functions.breakpoints.md) {
            stickyCheckout();
        }

        let shippingMethods = document.querySelectorAll('.shipping_method');

        function getCookie(name){
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }

        function eraseCookie(name){
            document.cookie = name + '=; Max-Age=-99999999;';
        }

        if (getCookie('parcel_id') && getCookie('parcel_desc')) {
            eraseCookie('parcel_id');
            eraseCookie('parcel_desc');
        }
        shippingMethods.forEach(el => {
            el.addEventListener('click', () => {
                let inpostBtn = document.getElementById('geowidget_show_map');
                if (el.value === 'easypack_parcel_machines') {
                    inpostBtn.classList.remove('d-none');
                } else {
                    inpostBtn.classList.add('d-none');
                    eraseCookie('parcel_id');
                    eraseCookie('parcel_desc');
                }
            });
        });


        $('input[name="clientType"]').on('change', function (){
            if ($(this).val() === 'company') {
                $('.nip-field').removeClass('d-none').addClass('validate-required');
                $('.company-name-field').removeClass('d-none').addClass('validate-required');
                $('.nip-field label').html('NIP <abbr class="required" title="required">*</abbr>');
                $('.company-name-field label').html('Nazwa firmy <abbr class="required" title="required">*</abbr>');
            } else {
                $('.nip-field').addClass('d-none').removeClass('validate-required').prop('required', false);
                $('.company-name-field').addClass('d-none').removeClass('validate-required').prop('required', false);
            }
        });

    }
}

export default {init};


// WEBPACK FOOTER //
// ./src/scripts/checkout-page.js